import type { FC, ReactNode } from 'react';
import { Route as RouteRR } from 'react-router';

interface BaseProps {
    children?: ReactNode;
    element?: ReactNode;
    path?: string;
    index?: boolean;
    condition?: () => boolean;
}

type PropsWithChildren = {
    children: ReactNode;
} & BaseProps;

type PropsWithElement = {
    element: ReactNode;
} & BaseProps;

type CustomRouteType = FC<PropsWithChildren | PropsWithElement>;

// we still need to use original react-router component, as the library checks the type, so we just cast it to our custom type
export const Route = RouteRR as CustomRouteType;
